import Vue from 'vue'
import VueRouter from 'vue-router'
import portal from './portal'
import publish from './publish'
import system from './system'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    ...portal,
    ...system,
    ...publish
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js